<template>
	<div data-tour-scope="cart-abandoned">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.cartadandoned') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-chip v-if="total" small outlined color="primary" class="ml-3">
								{{ total === 1 ? '1 cliente con carrello in sospeso' : total + ' clienti con carrello in sospeso' }}
							</v-chip>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="6" data-tour="search">
									<v-text-field
										v-model="searchfield"
										label="Cerca cliente (nome, cognome o email)"
										outlined
										dense
										hide-details
										clearable
										append-icon="mdi-magnify"
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										@click:clear="clearSearch()"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.lang" :items="lingue" label="Lingua" multiple clearable outlined dense hide-details></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							:loading="loading"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards cart-cards': mobileCards }"
							no-data-text="Nessun carrello abbandonato"
						>
							<template v-slot:item="{ item }">
								<!-- telefono: ogni carrello e' una card; il "+" apre il dettaglio DENTRO la card -->
								<tr v-if="mobileCards">
									<td :colspan="headers.length" class="px-3 py-1">
										<key-value-card :fields="campiCard(item)">
											<template v-slot:title>
												<span data-tour="name">{{ nomeCliente(item) || 'Cliente senza nome' }}</span>
											</template>
											<template v-slot:actions>
												<v-menu bottom right eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu" @click.stop>
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item v-if="haCliente(item)" link @click="goToCustomerDetail(item)">
															<v-list-item-title class="size9">Apri scheda cliente</v-list-item-title>
														</v-list-item>
														<v-list-item v-if="numeroWhatsapp(item)" link @click="contactWhatsapp(item)">
															<v-list-item-title class="size9">Scrivi su WhatsApp</v-list-item-title>
														</v-list-item>
														<v-list-item v-if="emailCliente(item)" link :href="'mailto:' + emailCliente(item)">
															<v-list-item-title class="size9">Scrivi una email</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="toggle(item._id)">
															<v-list-item-title class="size9">{{ aperto(item._id) ? 'Chiudi carrello' : 'Mostra carrello' }}</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn v-if="numeroWhatsapp(item)" small icon color="green" data-tour="whatsapp" title="Scrivi su WhatsApp" @click="contactWhatsapp(item)">
													<v-icon small>mdi-whatsapp</v-icon>
												</v-btn>
												<v-btn small icon color="primary" data-tour="expand" :title="aperto(item._id) ? 'Chiudi' : 'Mostra carrello'" @click="toggle(item._id)">
													<v-icon>{{ aperto(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</template>
											<template v-slot:top>
												<div class="d-flex align-center mb-1">
													<div class="ct-mini-thumbs">
														<span v-for="r in miniature(item)" :key="r.key" class="ct-mini-thumb">
															<img :src="r.immagine" alt="" loading="lazy" />
														</span>
													</div>
													<span class="ct-sub">{{ quandoFa(item.created_at) }}</span>
													<v-spacer></v-spacer>
													<span v-if="item.lang" class="ct-lang">{{ String(item.lang).toUpperCase() }}</span>
												</div>
											</template>
											<CartDetail
												v-if="aperto(item._id)"
												:item="item"
												:righe="righe(item)"
												:whatsapp="numeroWhatsapp(item)"
												@whatsapp="contactWhatsapp(item)"
												@open-customer="goToCustomerDetail(item)"
											/>
										</key-value-card>
									</td>
								</tr>
								<template v-else>
									<tr class="ct-list-row" :class="{ 'ct-list-row--open': aperto(item._id) }" @click="toggle(item._id)">
										<td class="pl-2 pr-0" style="width: 40px" @click.stop>
											<v-menu bottom right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu" @click.stop>
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list dense>
													<v-list-item v-if="haCliente(item)" link @click="goToCustomerDetail(item)">
														<v-list-item-title class="size9">Apri scheda cliente</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="numeroWhatsapp(item)" link @click="contactWhatsapp(item)">
														<v-list-item-title class="size9">Scrivi su WhatsApp</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="emailCliente(item)" link :href="'mailto:' + emailCliente(item)">
														<v-list-item-title class="size9">Scrivi una email</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="toggle(item._id)">
														<v-list-item-title class="size9">{{ aperto(item._id) ? 'Chiudi carrello' : 'Mostra carrello' }}</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td class="pl-0 pr-0" style="width: 40px">
											<v-btn small icon data-tour="expand" :title="aperto(item._id) ? 'Chiudi' : 'Mostra carrello'" @click.stop="toggle(item._id)">
												<v-icon>{{ aperto(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
											</v-btn>
										</td>
										<td class="ct-nowrap">
											<div>{{ item.created_at | moment('DD/MM/YYYY') }}</div>
											<div class="ct-sub">{{ item.created_at | moment('HH:mm') }} · {{ quandoFa(item.created_at) }}</div>
										</td>
										<td>
											<div data-tour="name" class="font-weight-medium">{{ nomeCliente(item) || '-' }}</div>
											<div class="ct-sub" data-tour="email">{{ emailCliente(item) }}</div>
										</td>
										<td>
											<div class="d-flex align-center">
												<div class="ct-mini-thumbs">
													<span v-for="r in miniature(item)" :key="r.key" class="ct-mini-thumb">
														<img :src="r.immagine" alt="" loading="lazy" />
													</span>
												</div>
												<div>
													<div>{{ testoPezzi(item) }}</div>
													<div class="ct-sub">{{ euro(riepilogo(item).valore) }} stimati</div>
												</div>
											</div>
										</td>
										<td>
											<span v-if="item.lang" class="ct-lang">{{ String(item.lang).toUpperCase() }}</span>
										</td>
										<td class="ct-nowrap" @click.stop>
											<span v-if="telefonoCliente(item)" class="mr-1">{{ telefonoCliente(item) }}</span>
											<v-btn v-if="numeroWhatsapp(item)" small icon color="green" data-tour="whatsapp" title="Scrivi su WhatsApp" @click="contactWhatsapp(item)">
												<v-icon small>mdi-whatsapp</v-icon>
											</v-btn>
											<v-btn v-if="emailCliente(item)" small icon color="primary" title="Scrivi una email" :href="'mailto:' + emailCliente(item)">
												<v-icon small>mdi-email-outline</v-icon>
											</v-btn>
										</td>
									</tr>
									<tr v-if="aperto(item._id)" class="ct-expanded">
										<td :colspan="headers.length" class="py-3">
											<CartDetail :item="item" :righe="righe(item)" :whatsapp="numeroWhatsapp(item)" @whatsapp="contactWhatsapp(item)" @open-customer="goToCustomerDetail(item)" />
										</td>
									</tr>
								</template>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import CartDetail from '@/components/cart/CartDetail.vue';
import { righeCarrello, riepilogoCarrello, euro } from '@/components/cart/righeCarrello';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { openWithReturn } from '@/components/core/pageReturn';

const LIST_SIZE = [15, 25, 50, 100];
import { createCartAbandonedTourSteps, stopCartAbandonedTour } from './cart-abandoned-tour';

export default {
	name: 'CartAbandoned',
	// pagina, righe, ordinamento, ricerca e lingua nell'URL: refresh e ritorno dalla scheda cliente ripartono da li'
	mixins: [listRouteState({ filters: { lang: 'array' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita' da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createCartAbandonedTourSteps(), { onStop: stopCartAbandonedTour }),
		};
	},
	components: {
		TourOverlay,
		KeyValueCard,
		CartDetail,
	},
	data() {
		return {
			loading: false,
			total: 0,
			// righe aperte (id cliente)
			aperti: [],
			listSize: LIST_SIZE,
			searchfield: '',
			settings: this.listSettingsFromRoute({
				search: '',
				filters: { lang: [] },
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			headers: [
				{ text: '', value: 'menu', sortable: false },
				{ text: '', value: 'expand', sortable: false },
				{ text: 'Ultima attività', value: 'created_at' },
				{ text: 'Cliente', value: 'customer.buyer.name' },
				{ text: 'Carrello', value: 'items', sortable: false },
				{ text: 'Lingua', value: 'lang', sortable: false },
				{ text: 'Contatti', value: 'customer.phone', sortable: false },
			],
		};
	},
	computed: {
		...mapGetters({
			getOrders: 'orders/getOrders',
			getSetting: 'settings/getSetting',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// lingue attive del profilo, per il filtro Lingua
		lingue() {
			return ((this.getSetting && this.getSetting.languages) || []).filter(l => l.is_active !== false).map(l => l.lang);
		},
		// righe normalizzate per carrello, ricalcolate quando arrivano i nomi delle varianti
		righePerCarrello() {
			const varianti = (this.getSetting && this.getSetting.variants) || [];
			const mappa = {};
			for (const carrello of this.getOrders || []) {
				mappa[carrello._id] = righeCarrello(carrello, varianti);
			}
			return mappa;
		},
	},
	mounted() {
		this.setDialog(false);
		// i nomi delle varianti (e le lingue del filtro) stanno nelle impostazioni del profilo
		this.fetchSetting();
		// stato della lista letto dall'URL in data()
		this.listLoad();
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
		}),
		...mapActions({
			fetchCarts: 'orders/asyncFetchCartData',
			fetchSetting: 'settings/asyncFetchData',
			destroyData: 'orders/destroyData',
		}),
		euro,
		async getDataFromApi() {
			this.loading = true;
			try {
				const pagination = await this.fetchCarts(this.settings);
				this.total = (pagination && pagination.total) || 0;
				this.aperti = [];
			} catch (err) {
				console.log(err);
			}
			this.loading = false;
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield.trim() : '';
		},
		clearSearch() {
			this.searchfield = '';
			this.settings.search = '';
		},
		toggle(id) {
			const i = this.aperti.indexOf(id);
			if (i === -1) this.aperti.push(id);
			else this.aperti.splice(i, 1);
		},
		aperto(id) {
			return this.aperti.includes(id);
		},
		righe(item) {
			return this.righePerCarrello[item._id] || [];
		},
		riepilogo(item) {
			return riepilogoCarrello(this.righe(item));
		},
		testoPezzi(item) {
			const n = this.riepilogo(item).pezzi;
			return n === 1 ? '1 articolo' : `${n} articoli`;
		},
		// prime tre immagini del carrello per l'anteprima in riga
		miniature(item) {
			return this.righe(item)
				.filter(r => r.immagine)
				.slice(0, 3);
		},
		haCliente(item) {
			return !!(item.customer && item.customer.buyer && item.customer.buyer.id);
		},
		nomeCliente(item) {
			const buyer = item.customer && item.customer.buyer;
			return buyer ? [buyer.name, buyer.lastname].filter(Boolean).join(' ') : '';
		},
		emailCliente(item) {
			return (item.customer && item.customer.buyer && item.customer.buyer.email) || '';
		},
		telefonoCliente(item) {
			return (item.customer && item.customer.phone) || '';
		},
		// coppie chiave/valore della card da telefono
		campiCard(item) {
			const r = this.riepilogo(item);
			return [
				{ label: 'Ultima attività', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm') : '' },
				{ label: 'Email', value: this.emailCliente(item) },
				{ label: 'Telefono', value: this.telefonoCliente(item) },
				{ label: 'Carrello', value: this.testoPezzi(item) },
				{ label: 'Valore stimato', value: this.euro(r.valore), strong: true },
			];
		},
		quandoFa(data) {
			if (!data) return '';
			const giorni = this.$moment().startOf('day').diff(this.$moment(data).startOf('day'), 'days');
			if (giorni <= 0) return 'oggi';
			if (giorni === 1) return 'ieri';
			if (giorni < 30) return `${giorni} giorni fa`;
			const mesi = Math.floor(giorni / 30);
			return mesi === 1 ? '1 mese fa' : `${mesi} mesi fa`;
		},
		// solo cellulari italiani di dieci cifre, con o senza prefisso 39
		numeroWhatsapp(item) {
			const cleaned = ('' + this.telefonoCliente(item)).replace(/\D/g, '');
			const match = cleaned.match(/^(39|)?(\d{3})(\d{3})(\d{4})$/);
			return match ? ['+39', match[2], match[3], match[4]].join('') : null;
		},
		contactWhatsapp(item) {
			const nome = item.customer && item.customer.buyer && item.customer.buyer.name;
			const message = `Buongiorno${nome ? ' ' + nome : ''}, la contatto perché ha lasciato alcuni articoli nel carrello sul nostro sito: posso aiutarla a completare l'ordine?`;
			const url = `https://api.whatsapp.com/send?phone=${this.numeroWhatsapp(item)}&text=${encodeURIComponent(message)}`;
			window.open(url, '_blank');
		},
		// la scheda cliente e' una pagina: Annulla/Salva tornano qui, alla stessa pagina della lista
		goToCustomerDetail(item) {
			if (item.customer && item.customer._id) openWithReturn(this, { path: `/customers/${item.customer._id}` }, { label: 'Torna ai carrelli abbandonati' });
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100%.
   La tabella usa lo slot `item`: il tbody lo genera v-data-table, quindi serve ::v-deep */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.cart-cards ::v-deep tbody,
.cart-cards ::v-deep tbody tr {
	display: block;
	width: 100%;
}
.cart-cards ::v-deep tbody tr,
.cart-cards ::v-deep tbody tr:hover {
	background: transparent !important;
}
.cart-cards ::v-deep tbody td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.cart-cards ::v-deep tbody tr:first-child td {
	padding-top: 12px !important;
}
.cart-cards ::v-deep tbody tr:last-child td {
	padding-bottom: 12px !important;
}
.cart-cards ::v-deep tbody tr + tr td {
	padding-top: 8px !important;
}
/* lista compatta */
.ct-list-row {
	cursor: pointer;
}
.ct-list-row--open,
.ct-list-row--open:hover {
	background: #f3f6fa !important;
}
.ct-expanded,
.ct-expanded:hover {
	background: transparent !important;
}
.ct-nowrap {
	white-space: nowrap;
}
.ct-sub {
	font-size: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.ct-lang {
	display: inline-block;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.04em;
	padding: 1px 6px;
	border-radius: 4px;
	border: 1px solid #e1e7ef;
	background: #f7f9fc;
	color: #5f6b7a;
}
/* miniature sovrapposte degli articoli nel carrello */
.ct-mini-thumbs {
	display: flex;
	margin-right: 10px;
}
.ct-mini-thumb {
	width: 32px;
	height: 32px;
	border-radius: 6px;
	border: 1px solid #e1e7ef;
	background: #f7f9fc;
	overflow: hidden;
	flex: 0 0 32px;
}
.ct-mini-thumb + .ct-mini-thumb {
	margin-left: -10px;
}
.ct-mini-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #fff;
}
</style>
